import { OPEN_API } from './index';
const endpoints = {
    getRallies: '/rallies',
};
export const getRallies = async (queryParams) => {
    return await OPEN_API.GET.all({ endpoint: endpoints.getRallies, queryParams });
};
export const getRally = async (id) => {
    return await OPEN_API.GET.single({ endpoint: endpoints.getRallies, id });
};
